import { isHexColor } from './colors';

export interface CellColorChange {
  rowKey: string;
  field: string;
  color: string | null;
}

export interface CellColorRange {
  rowMin: number;
  rowMax: number;
  colMin: number;
  colMax: number;
}

export interface CellColorTarget {
  rowKey: string;
  field: string;
}

/** Map key for one cell. Fields are first to match the formula override map. */
export const cellColorKey = (field: string, rowKey: string): string =>
  `${field}|${rowKey}`;

/** Canonicalize user-picked colors before they enter local state or Supabase. */
export function normalizeCellColor(value: unknown): string | null {
  if (typeof value !== 'string' || !isHexColor(value)) return null;
  return value.toUpperCase();
}

/** Resolve a visual range into only persistable data cells. */
export function cellColorTargetsForRange(
  range: CellColorRange | null,
  rowKeys: readonly string[],
  visibleColumns: readonly number[],
  fields: readonly (string | undefined)[],
): CellColorTarget[] {
  if (!range) return [];

  const targets: CellColorTarget[] = [];
  const firstDataColumn = Math.max(range.colMin, 1);
  for (let rowPos = range.rowMin; rowPos <= range.rowMax; rowPos += 1) {
    const rowKey = rowKeys[rowPos];
    if (!rowKey) continue;
    for (let columnPos = firstDataColumn; columnPos <= range.colMax; columnPos += 1) {
      const originalColumn = visibleColumns[columnPos - 1];
      const field = originalColumn === undefined ? undefined : fields[originalColumn];
      if (field) targets.push({ rowKey, field });
    }
  }
  return targets;
}
